import React, { useContext, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { showModal } from '../actions/modal';

import * as ElectronService from '../services/electron-service';

import { WebexContext } from 'context/WebexContext';

import AppFeatured from './app-featured';
import HideInIframe from './HideInIframe';
import AuthDisabled from './AuthDisabled';
import AppLogin from './AppLogin';
import NiftyLogo from './NiftyLogo';

const AuthFlow = () => {
    const webexCtx = useContext(WebexContext);
    const history = useHistory();

    const handleSignupClick = useCallback(email => {
        history.push({
            pathname: '/signup/email',
            search:  (window.location && window.location.search),
            hash: email ? `email=${email}` : '',
            state: {
                backUrl: '/login'
            }
        });
    }, []);

    const handleNewTeamClick = useCallback(() => {
        showModal('CREATE_TEAM');
    }, []);

    useEffect(() => {
        ElectronService.emit('logout');
    }, []);

    return (
        <div className="app-main with-background">
            <div className="auth-flow">
                <div className="auth-flow-inner">
                    <div className="auth-flow-head">
                        <a href="https://niftypm.com">
                            <NiftyLogo size={101} />
                        </a>
                    </div>

                    <div className="auth-flow-main">
                        {
                            !webexCtx?.inApp ? (
                                <AppFeatured />
                            ) : null
                        }

                        {
                            !webexCtx?.inApp ? (
                                <React.Fragment>
                                    <HideInIframe>
                                        <div className="auth-flow-body">
                                            <AppLogin onSignupClick={handleSignupClick} />
                                        </div>
                                    </HideInIframe>

                                    <HideInIframe reverse={true}>
                                        <div className="auth-flow-body">
                                            <AuthDisabled />
                                        </div>
                                    </HideInIframe>
                                </React.Fragment>
                            ) : (
                                <div className="auth-flow-body">
                                    <AppLogin onSignupClick={handleSignupClick} />
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AuthFlow;
